export const Colors = {
    primaryMain : "#1D99BE !important",
    primaryLite : "#D9EDF3 !important",
    primaryButtonHover : "#33A3C4 !important",
    secoundaryBackgorund : "#FDBB2E !important",
    secoundaryLite : "#FFF7E5 !important"
}